import React, { useContext, useEffect, useState } from 'react';
import ValueContext from './Context';
import './Infobar.css';

export default function Infobar(props) {
  const {
    version,
    premium,
    quadro,
    locale,
    getText,
  } = useContext(ValueContext);
  const [text, settext] = useState(getText());

  useEffect(() => {
    settext(getText());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);

  return <div className='Infotext'> {text.Infobar.Config}: MultiControl II {quadro ? 'quadro' : 'duo'};
  {premium ? ' Premium' : text.Infobar.Normal } {text.Infobar.Variant};
   {text.Infobar.SWVersion} {version} <span onClick={() => props.onclick()} className='MenuSwitch'>{text.Infobar.Change}</span></div>;
}
